/* file description */
import * as React from 'react';
import { Modal } from 'antd';
import { Popup, Button } from 'antd-mobile';
import useMetaStore from '@/store/useMetaStore';

export const ModalLayout = (props: any) => {
  const { isMobile } = useMetaStore();

  if (isMobile) {
    return (
      <Popup
        {...props}
        mask
        onMaskClick={props.onCancel}
        bodyStyle={{ padding: '20px 10px 0px 10px' }}
      >
        <div
          style={{ height: props?.mobileHeight || '40vh', overflowY: 'scroll' }}
        >
          {props.children}
        </div>
        {
            props?.onOk && <Button block color="primary" onClick={props.onOk}>{props?.okText || '确定'} </Button>
          }
      </Popup>
    );
  }

  return (
    <Modal maskClosable={false} {...props} > {props.children} </Modal>
  );
};
